import React from 'react'
import PropTypes from 'prop-types'
import { Pagination } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

import { pagination } from '../../helpers/paginationHelpers'

const Pagination3 = ({
  activePage,
  className,
  id,
  itemsPerPage,
  itemsTotal,
  onChange,
  showDirections,
  text,
  url
}) => {
  const pageCount = Math.ceil(itemsTotal / itemsPerPage)
  const getUrl = pageNumber => url.replace('%7Bpage%7D', pageNumber)
  return (
    <Pagination id={id} bsSize='medium' className={className}>
      {showDirections
        ? ([
        <LinkContainer
          key={`paginationFirst${id}`}
          to={getUrl(1)}
        >
          <Pagination.Item
            className='pagination__first'
            disabled={activePage === 1}
            onClick={() => onChange(1)}
          >
            «
          </Pagination.Item>
        </LinkContainer>,
        <LinkContainer
          key={`paginationPrev${id}`}
          to={getUrl(activePage - 1)}
        >
          <Pagination.Item
            className='pagination__prev'
            disabled={activePage === 1}
            onClick={() => onChange(activePage - 1)}
          >
            ‹
          </Pagination.Item>
        </LinkContainer>
          ])
        : null}
      {pagination(activePage, pageCount)
        .map((pageNumber, index) => (pageNumber === '…')
          ? (
            <Pagination.Ellipsis
              className='pagination__ellipsis'
              key={`pagination${id}Ellipsis${index}`}
              disabled
            />
            )
          : (
            <LinkContainer
              key={`pagination${id}Page${pageNumber}`}
              to={getUrl(pageNumber)}
            >
              <Pagination.Item
                className='pagination__number'
                active={activePage === pageNumber}
                onClick={() => onChange(pageNumber)}
              >
                {pageNumber}
              </Pagination.Item>
            </LinkContainer>
            ))}
      {showDirections
        ? ([
        <LinkContainer
          key={`paginationNext${id}`}
          to={getUrl(activePage + 1)}
        >
          <Pagination.Item
            className='pagination__next'
            disabled={activePage === pageCount}
            onClick={() => onChange(activePage + 1)}
          >
            ›
          </Pagination.Item>
        </LinkContainer>,
        <LinkContainer
          key={`paginationLast${id}`}
          to={getUrl(pageCount)}
        >
          <Pagination.Item
            className='pagination__last'
            disabled={activePage === pageCount}
            onClick={() => onChange(pageCount)}
          >
            »
          </Pagination.Item>
        </LinkContainer>
          ])
        : null}
      {text
        ? (
        <Pagination.Item
          className='pagination__text'
          disabled
        >
          {text}
        </Pagination.Item>
          )
        : null}
    </Pagination>
  )
}

Pagination3.propTypes = {
  activePage: PropTypes.number.isRequired,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  itemsTotal: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  showDirections: PropTypes.bool,
  text: PropTypes.string,
  url: PropTypes.string
}

Pagination3.defaultProps = {
  activePage: 1,
  itemsPerPage: 20,
  itemsTotal: 20,
  showDirections: false
}

export default React.memo(Pagination3)
